import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import DuNoChoVayApi from "service/duNoChoVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
export const ModalChiTiet = (props) => {
  useEffect(() => {
    DanhSachChiTiet(1);
  }, []);

  const dataInit = {
    List: [],
    TongDuNo: 0,
    TongBanGhi: 0,
  };
  const [dataChiTiet, UpdateDataChiTiet] = useState(dataInit);
  const [pageIndex, setPageIndex] = useState(1);
  const DanhSachChiTiet = (page) => {
    DuNoChoVayApi.getListChiTietDuNo(
      props.fromDate,
      props.toDate,
      5,
      props.type,
      page,
      20
    ).then((response) => {
      UpdateDataChiTiet({
        ...dataChiTiet,
        List: response.data.List,
        TongDuNo: response.data.TongDuNo,
        TongBanGhi: response.data.TongBanGhi,
      });
    });
  };

  const PhanTrang = (index) => {
    setPageIndex(index);
    DanhSachChiTiet(index);
  };

  const duNoTye =
    props.type === 2 ? "nợ xấu" : props.type === 3 ? "rủi ro" : "thường";

  const listItem = () => {
    return (
      dataChiTiet.List != null &&
      dataChiTiet.List.map((item, index) => {
        return (
          <tr key={"item" + index}>
            <th scope="row">{index + 1 + (pageIndex - 1) * 20}</th>
            <td>
              <BtnChiTietHopDong item={item} />
            </td>
            <td>
              <BtnChiTietKhachhang item={item} />
            </td>
            <td>{getDate(item.NgayVay)}</td>
            <td>{getDate(item.NgayTra)}</td>
            <td className="text-right">
              <span className="red">{formatNumber(item.SoTienVayConLai)}</span>
            </td>
          </tr>
        );
      })
    );
  };
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>{" "}
          Tổng dư nợ {duNoTye} bán hàng trả góp
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253128"
                className="card-header border-info"
                href="#collapse253128"
                aria-expanded="true"
                aria-controls="collapse25312"
              >
                <a className="card-title lead info collapsed">
                  <h3>Chi tiết dư nợ {duNoTye} trả góp</h3>
                </a>
              </div>
              <div
                id="collapse2531288"
                role="tabpanel"
                aria-labelledby="headingCollapse253128"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="Left-table">
                      <div className="table-responsive table-1">
                        <table className="table table-bordered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th>
                                STT
                                <br />{" "}
                                <span className="color-do-bold">
                                  [ {dataChiTiet.TongBanGhi} ]
                                </span>
                              </th>
                              <th>Mã cho vay</th>
                              <th>Tên khách hàng</th>
                              <th>Ngày vay</th>
                              <th>Ngày trả</th>
                              <th className="text-right">
                                Số dư nợ rủi ro
                                <br />{" "}
                                <span className="color-do-bold">
                                  {formatNumber(dataChiTiet.TongDuNo)}
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>{listItem()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12  col-md-6">
                <span className="color7">
                  {dataChiTiet.TongBanGhi === 0 ? (
                    "Hiển thị 0 - 0 / Tổng số 0"
                  ) : (
                    <>
                      Hiển thị {(pageIndex - 1) * 20 + 1} -{" "}
                      {Math.min(pageIndex * 20, dataChiTiet.TongBanGhi)} / Tổng
                      số {dataChiTiet.TongBanGhi}
                    </>
                  )}
                </span>
              </div>
              <div className="col-sm-12  col-md-6">
                <div
                  className={
                    "paniation-new paniation-new1 d-flex justify-content-center " +
                    (dataChiTiet.TongBanGhi === 0 ? "hidden" : "")
                  }
                  style={{ float: "right" }}
                >
                  <nav aria-label="Page navigation">
                    <Pagination
                      activePage={pageIndex}
                      itemsCountPerPage={20}
                      totalItemsCount={dataChiTiet.TongBanGhi}
                      pageRangeDisplayed={5}
                      onChange={PhanTrang}
                      itemClass="page-item border-none"
                      linkClass="page-link border-none"
                      activeClass="active"
                    />
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
